import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { childrenOfType } from '@datacamp/waffles-utils';
import PropTypes from 'prop-types';
import React from 'react';
import Label from '../Label';
import Checkbox from './Checkbox';
import CheckboxListContext from './CheckboxListContext';
import { jsx as ___EmotionJSX } from "@emotion/react";

var CheckboxList = function CheckboxList(_ref) {
  var children = _ref.children,
      description = _ref.description,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      errorMessage = _ref.errorMessage,
      label = _ref.label,
      name = _ref.name,
      onChange = _ref.onChange,
      required = _ref.required,
      value = _ref.value;
  var handleChange = React.useCallback(function (changedValue) {
    // removes if already exists, adds if it doesn't
    var newValue = value.includes(changedValue) ? value.filter(function (item) {
      return item !== changedValue;
    }) : _toConsumableArray(new Set(value.concat(changedValue))); // array union

    onChange(newValue);
  }, [onChange, value]);
  return ___EmotionJSX(Label, {
    as: "fieldset",
    description: description,
    errorMessage: errorMessage,
    label: label,
    required: required
  }, ___EmotionJSX("div", null, ___EmotionJSX(CheckboxListContext.Provider, {
    value: {
      disabled: disabled,
      hasError: !!errorMessage,
      name: name,
      onChange: handleChange,
      value: value
    }
  }, children)));
};

CheckboxList.propTypes = process.env.NODE_ENV !== "production" ? {
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  required: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
  description: PropTypes.string,

  /**
   * Takes multiple `Checkbox` components as children.
   */
  children: PropTypes.arrayOf(childrenOfType(Checkbox).isRequired).isRequired
} : {};
export default CheckboxList;